/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { GET_USERS_QUERY } from '../../queries';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { UserOutput, UserQuery } from '../../gql/graphql';
import { GET_USER_DETAIL_QUERY } from '../../queries/user/getUsers';

export const useUsers = (queries: UserQuery) => {
  return useQuery<{ data: UserOutput[]; total: number }, Error>({
    queryKey: ['users', queries],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getUsers: { total: number; data: UserOutput[] } },
        { queries: UserQuery }
      >(GET_USERS_QUERY, { queries });
      return {
        data: data.getUsers.data,
        total: data.getUsers.total,
      };
    },
  });
};

export const useUserDetail = (id: string) => {
  return useQuery<UserOutput, Error>({
    queryKey: ['user', id],
    queryFn: async () => {
      const data = await graphqlFetch<{ getUser: UserOutput }, { id: string }>(
        GET_USER_DETAIL_QUERY,
        { id },
      );
      return data.getUser;
    },
    enabled: !!id,
  });
};
